import { combineReducers } from 'redux';
import auth from './auth';
import user from './user';
import userMenu from './usermenu';
import admin from './admin';
import scrollTo from './scrollTo';
import loading from './loading';
import menuPosition from './menuPosition';
import cart from './cart';
import categories from './categories';
import selectedCat from './selectedCat';
export default combineReducers({
  auth,
  user,
  userMenu,
  admin,
  scrollTo,
  loading,
  menuPosition,
  cart,
  categories,
  selectedCat
})



// WEBPACK FOOTER //
// ./src/reducers/index.js